import { useRouter } from 'next/router';
import React from 'react';

import DownloadAppCardCmp from '../../../../containers/download-app/view/components/DownloadAppCardCmp';
import { useAuthContext } from '../../../../containers/login/view-model/contexts/auth-context/AuthContextV1';
import NextImageV2 from '../../../../ui/components/NextImageV2';
import * as LocaleConstants from '../../../constants/LocaleConstants';
import {
  download_app_mobile_menu as downloadAppMobileMenu,
  download_card_track_order as downloadCardTrackOrder,
} from '../../../download-app/constants/DownloadAppStore';
import { enableMobileBookingFlow } from '../../../helpers/LocaleHelpers';
import { logoutHandler } from '../helpers/HeaderLogoutHelper';
import styles from '../styles/MobileMenu.module.scss';
import { MenuContent, getMenuLinks } from '../vm/HeaderVm';

import MobileMenuAuthSection from './MobileMenuAuthSection';
import MobileMenuLinksCmp from './MobileMenuLinksCmp';
import MobileMenuLogoutSection from './MobileMenuLogoutSection';

interface MobileMenuCmpProps {
  set_is_mobile_menu_open: (updater: (prev: boolean) => boolean) => void;
  data: MenuContent;
}

function MobileMenuCmp({
  set_is_mobile_menu_open,
  data,
}: Readonly<MobileMenuCmpProps>): React.ReactElement {
  const router = useRouter();
  const isDom = router.locale === LocaleConstants.en_IN;
  const menuLinks = getMenuLinks(data.links, isDom);
  const { set_user, is_authenticated, set_is_authenticated, order_history } =
    useAuthContext();
  const isBookingFlowEnabled = enableMobileBookingFlow(router.locale);

  return (
    <div className={styles['mobile-menu-wrapper']}>
      <div className={styles['mobile-menu-container']}>
        <button
          type="button"
          className={styles['close-icon']}
          onClick={(): void => set_is_mobile_menu_open(prev => !prev)}
        >
          <NextImageV2
            src={data.close_icon.path}
            alt={data.close_icon.alt_text}
            height={16}
            width={16}
            quality={100}
          />
        </button>
        <div className={styles['links-container']}>
          <MobileMenuAuthSection
            isBookingFlowEnabled={isBookingFlowEnabled}
            is_authenticated={is_authenticated}
            order_history={order_history}
          />
          <MobileMenuLinksCmp
            links={menuLinks}
            container_class={styles['primary-links']}
            child_class={styles['primary-link']}
            on_click={(): void => set_is_mobile_menu_open(prev => !prev)}
          />
          <MobileMenuLogoutSection
            is_authenticated={is_authenticated}
            onLogout={(): void => {
              void logoutHandler(
                set_user,
                set_is_authenticated,
                set_is_mobile_menu_open,
              );
            }}
          />
        </div>
        <DownloadAppCardCmp
          data={downloadCardTrackOrder}
          image={downloadAppMobileMenu}
        />
      </div>
    </div>
  );
}

export default MobileMenuCmp;
